import React from "react";
import {firebase} from "../../../firebase";

function GoogleLogin({onFinishLogin}) {

    // Create a Google authentication provider
    const provider = new firebase.auth.GoogleAuthProvider();

    const handleGoogleLogin = () => {
        firebase
            .auth()
            .signInWithPopup(provider)
            .then((result) => {
                // Google login successful
                onFinishLogin();
            })
            .catch((error) => {
                // An error occurred during Google login
                console.error('Google login error:', error);
            });
    };

    return (
        <button onClick={handleGoogleLogin} className="btn btn-outline-primary">
            Iniciar sesión con&nbsp;<i className="fa-brands fa-google"/>
        </button>
    )
}

export default GoogleLogin;
